import * as PIXI from 'pixi.js';

const cache = new Map<string, PIXI.Texture>();

const SPRITE_PATHS: Record<string, string> = {
  hamster: '/assets/sprites/hamster_idle.png',
  hamster_right: '/assets/sprites/hamster_right.png',
  enemy_basic: '/assets/sprites/enemy_basic.png',
  enemy_support: '/assets/sprites/enemy_support.png',
  enemy_armored: '/assets/sprites/enemy_armored.png',
  enemy_spammer: '/assets/sprites/enemy_spammer.png',
  enemy_investor: '/assets/sprites/enemy_investor.png',
  boss: '/assets/sprites/boss.png',
  coin: '/assets/sprites/coin.png',
  key: '/assets/sprites/key.png',
  bullet: '/assets/sprites/bullet.png',
  pistol: '/assets/sprites/pistol.png',
  bush: '/assets/sprites/bush.png',
  wall: '/assets/sprites/wall.png',
  floor: '/assets/sprites/floor.png',
  heart_full: '/assets/sprites/heart_full.png',
  heart_empty: '/assets/sprites/heart_empty.png',
};

export async function preloadAllSprites(): Promise<void> {
  console.log('[SpriteCache] Starting preload...');
  for (const [key, path] of Object.entries(SPRITE_PATHS)) {
    try {
      const texture = await PIXI.Assets.load(path);
      cache.set(key, texture);
      console.log(`[SpriteCache] Loaded: ${key} (${texture.width}x${texture.height})`);
    } catch (e) {
      console.warn(`[SpriteCache] Failed to load ${key}:`, e);
    }
  }
  console.log(`[SpriteCache] Done. Cached: ${cache.size} textures`);
}

export function getSprite(key: string): PIXI.Texture | null {
  return cache.get(key) ?? null;
}
